// If a user uploads an audio file to Pipe, Pipe will set the snapshotUrl to
// one of these values
const audioOnlyPipeSnapshotUrls = ["audio_only", "audio_file"];
/**
 * NOTE that an empty URL is not considered an audio-only URL.
 */
export function getIsAudioOnlyPipeSnapshotUrl(maybePipeUrl) {
    if (!maybePipeUrl) {
        return false;
    }
    return audioOnlyPipeSnapshotUrls.includes(maybePipeUrl.toLocaleLowerCase());
}
export function getIsAudioOnlyPipeClip(metadata) {
    const snapshotUrl = metadata.data?.snapshotUrl;
    const videoCodec = metadata.data?.videoCodec;
    if (getIsAudioOnlyPipeSnapshotUrl(snapshotUrl)) {
        return true;
    }
    else if (videoCodec?.toLowerCase() === "no_video") {
        return true;
    }
    else {
        return false;
    }
}
